import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Delegate overview',
  description:
    'These are your transaction details. Make sure to check if this is correct before submitting.',

  boxDescription: 'Please submit to delegate',
  approveDescription: 'Please approve before delegation',
  successButtonTitle: 'Back to governance',

  delegationVotes: 'Voting power',
  delegationProposalPower: 'Proposition power',

  delegate: 'Delegate',
  type: 'Type',
  toAddress: 'To address',
});
